 document.addEventListener('DOMContentLoaded', async function () {

        // Wait for Shopify's currency to be available
        const checkCurrencyReady = () => {
            return new Promise(resolve => {
                if (Shopify.currency && Shopify.currency.active) {
                    resolve(Shopify.currency.active);
                } else {
                    const interval = setInterval(() => {
                        if (Shopify.currency && Shopify.currency.active) {
                            clearInterval(interval);
                            resolve(Shopify.currency.active);
                        }
                    }, 100);
                }
            });
        };

        let activeCurrency = await checkCurrencyReady();

        // Function to get the exchange rate
        async function getCurrencyRate() {
            try {
                const response = await fetch('https://api.exchangerate-api.com/v4/latest/USD');
                const data = await response.json();
                console.log('data', data)
                return data.rates[activeCurrency];
            } catch (error) {
                console.error('Error fetching exchange rate:', error);
                return null;
            }
        }

        // Function to check cart and handle checkout
        async function handleCheckout() {
            const exchangeRate = await getCurrencyRate();
            const minAmountUSD = 200;

            if (!exchangeRate) return console.error("Exchange rate not available.");

            const minimumAmountPurchase = minAmountUSD * exchangeRate;

            console.log("minimumAmountPurchase", minimumAmountPurchase)

            try {
                const cartRes = await fetch('/cart.js');
                const cart = await cartRes.json();
                const cartTotal = cart.original_total_price / 100;

                console.log(`Cart Total: ${cartTotal}, Minimum: ${minimumAmountPurchase} ${activeCurrency}`);

                if (cartTotal < minimumAmountPurchase) {
                    alert(`Minimum purchase is ${minimumAmountPurchase.toFixed(2)} ${activeCurrency}. Spend ${ (minimumAmountPurchase - cartTotal).toFixed(2) } ${activeCurrency} more to checkout.`);
                    return;
                }

                window.location.href = '/checkout';
            } catch (err) {
                console.error('Error fetching cart:', err);
            }
        }

        // Event delegation: listen for clicks on any checkout button, even if Shopify re-renders
        document.body.addEventListener('click', function(event) {
            const target = event.target.closest('.cart__checkout-button');
            if (!target) return;
            event.preventDefault();
            handleCheckout();
        });

        async function updateCartAttribute(){
            const exchangeRate = await getCurrencyRate();
            const minAmountUSD = 200;
                if (!exchangeRate) return console.error("Exchange rate not available.");
                const minimumAmountPurchase = minAmountUSD * exchangeRate;
                console.log("updateCartAttribute minimumAmountPurchase" , `${minimumAmountPurchase} ${activeCurrency}`)
                fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    attributes: {
                    cart_minimum_purchase_attribute: minimumAmountPurchase
                    }
                })
                })
                .then(res => res.json())
                .then(data => {
                    console.log("Cart updated:", data);
                });

        }

        updateCartAttribute();

        console.log("Checkout validation script is active and using delegated events.");
    });